<template>

    <div>
        <page-title :title="$t('articles.title')"></page-title>

        <div class="flex flex-col sm:flex-row md:mt-0 mb-4 sm:space-x-8 items-end">
            <div class="flex flex-row flex-1 w-full">
                <filter-menu>
                    <switch-input :label="$t('articles.sw')" v-model="form.sw"></switch-input>
                    <switch-input :label="$t('articles.tb')" v-model="form.tb"></switch-input>
                    <switch-input :label="$t('articles.gx')" v-model="form.gx"></switch-input>
                    <switch-input :label="$t('articles.ma')" v-model="form.ma"></switch-input>
                    <switch-input :label="$t('articles.protected')" v-model="form.protected"></switch-input>
                </filter-menu>

                <search-bar class="flex-1" :placeholder="$t('articles.search')" v-model="form.search"></search-bar>

                <sort v-model="form.sort" :options="sortOptions"></sort>

            </div>
        </div>
        <pagination class="my-6" :links="articles.links" prefix="t"></pagination>

        <div class="align-middle min-w-full overflow-x-auto shadow overflow-hidden sm:rounded-lg">
            <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                <tr>
                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('articles.sku') }}
                    </th>
                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('articles.ean') }}
                    </th>
                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('articles.description') }}
                    </th>
                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('articles.stock') }}
                    </th>

                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('articles.stockOverwrite') }}
                    </th>

                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('articles.price') }}
                    </th>

                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('articles.discountPrice') }}
                    </th>


                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('articles.stockProtected') }}
                    </th>

                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('articles.toTb') }}
                    </th>

                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('articles.toSw') }}
                    </th>

                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('articles.toGx') }}
                    </th>

                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('articles.toMa') }}
                    </th>

                </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="article in articles.data" :key="article.id">
                    <td class="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        {{ article.sku }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ article.ean }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        <TextLink :href="route('articles.edit', article.id)">
                            {{ article.name }}
                        </TextLink>
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ article.stock }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ article.stock_overwrite }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ article.price_incl }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ article.discount_price_incl }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        <checkbox disabled :checked="article.protected"></checkbox>
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        <checkbox disabled :checked="article.tb"></checkbox>
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        <checkbox disabled :checked="article.sw"></checkbox>
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        <checkbox disabled :checked="article.gx"></checkbox>
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        <checkbox disabled :checked="article.ma"></checkbox>
                    </td>
                </tr>
                </tbody>
            </table>


        </div>

        <pagination class="mt-6" :links="articles.links" prefix="b"></pagination>

    </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import PageTitle from "@/Shared/Components/PageTitle";
import {MagnifyingGlassIcon} from "@heroicons/vue/24/outline";
import SearchBar from "@/Shared/Components/SearchBar";
import Pagination from "@/Shared/Components/Pagination";
import {mapValues, pickBy, throttle} from "lodash";
import SwitchInput from "@/Shared/Components/SwitchInput";
import {ref} from "vue";
import Checkbox from "@/Jetstream/Checkbox";
import Sort from "@/Shared/Components/Sort";
import {i18n} from "@/app";
import FilterMenu from "@/Shared/Components/FilterMenu";
import TextLink from "@/Shared/Components/TextLink";

const {t} = i18n.global;

const sortOptions = [
    {id: 'sku', name: t('articles.sku')},
    {id: 'ean', name: t('articles.ean')},
    {id: 'name', name: t('articles.description')},
    {id: 'price_incl', name: t('articles.price')},
    {id: 'discount_price_incl', name: t('articles.discountPrice')},
    {id: 'stock', name: t('articles.stock')},
    {id: 'stock_overwrite', name: t('articles.stockOverwrite')},
]

export default {
    components: {
        TextLink,
        FilterMenu,
        Checkbox,
        Pagination,
        SearchBar,
        PageTitle,
        MagnifyingGlassIcon,
        SwitchInput,
        Sort,
    },
    layout: AppLayout,
    props: ['articles', 'filter', 'sort'],
    setup(props) {
        const form = ref({
            search: props.filter.search,
            sw: !!props.filter.sw,
            gx: !!props.filter.gx,
            tb: !!props.filter.tb,
            ma: !!props.filter.ma,
            protected: !!props.filter.protected,
            sort: props.sort
        })
        return {
            form,
            sortOptions
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                let query = {
                    "filter[search]": this.form.search,
                    "filter[sw]": this.form.sw === true,
                    "filter[gx]": this.form.gx === true,
                    "filter[tb]": this.form.tb === true,
                    "filter[ma]": this.form.ma === true,
                    "filter[protected]": this.form.protected === true,
                    "sort": this.form.sort
                };

                this.$inertia.get(this.route("articles.index"), pickBy(query), {
                    preserveState: true
                });
            }, 700)
        }
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null);
        }
    }

}
</script>

<style scoped>

</style>
